module.exports = __webpack_public_path__ + "static/img/doctor.b843827.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/report/doctor.png
// module id = AC53
// module chunks = 1